import apiClient from "../api/client";

let _cache = null;

/**
 * Default referrals config - used as fallback and initial render (no flicker).
 * Must stay in sync with backend config/referrals_config.py
 */
export const DEFAULT_REFERRALS_CONFIG = {
  l1_percent: 0.10,
  l1_duration: "lifetime",
  l2_percent: 0.05,
  l2_duration_days: 365,
  l2_duration_label: "12 months",
  l2_eligible_skus: ["ELITE_MONTHLY", "ELITE_PLUS_MONTHLY", "WINGMAN_PRO_MONTHLY", "INNER_CIRCLE_MONTHLY"],
  l2_eligible_product_rule: "monthly_subscriptions_only",
};

/**
 * Fetch referrals config from backend.
 * Caches result to avoid repeated calls.
 * Falls back to DEFAULT_REFERRALS_CONFIG on error.
 */
export async function fetchReferralsConfig() {
  if (_cache) return _cache;
  try {
    const res = await apiClient.get("/referrals/config");
    _cache = res.data || DEFAULT_REFERRALS_CONFIG;
    return _cache;
  } catch (e) {
    console.warn("[referralsConfig] Failed to fetch config, using defaults:", e?.message);
    return DEFAULT_REFERRALS_CONFIG;
  }
}

/**
 * Format percent for display (e.g., 0.10 -> "10%")
 */
export function formatPercent(decimal) {
  return `${Math.round((decimal || 0) * 100)}%`;
}
